import { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { createPerformanceLogger, logFunctionCall } from '../utils/performanceLogging';

const logger = createPerformanceLogger('availability');

export const useAvailability = (visibleRange) => {
  const [availability, setAvailability] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAvailability = async () => {
      const end = logger.start('fetch_availability');
      setIsLoading(true);
      const functions = getFunctions();
      const getAvailabilityData = httpsCallable(functions, 'getAvailabilityData');
      try {
        const callFunctionEnd = logger.start('call_function');
        const result = await logFunctionCall('getAvailabilityData', () => getAvailabilityData({
          startDate: visibleRange.start.toISOString().split('T')[0],
          endDate: visibleRange.end.toISOString().split('T')[0]
        }));
        callFunctionEnd();
        
        const processDataEnd = logger.start('process_data');
        setAvailability(result.data);
        processDataEnd();
      } catch (error) {
        // Error handling remains intact
      } finally {
        setIsLoading(false);
      }
      end();
    };
    fetchAvailability();
  }, [visibleRange]);

  const updateAvailability = async (updates, email) => {
    const end = logger.start('update_availability');
    const functions = getFunctions();
    const updateAvailabilityFunc = httpsCallable(functions, 'updateAvailability');
    try {
      const callFunctionEnd = logger.start('call_update_function');
      const result = await logFunctionCall('updateAvailability', () => updateAvailabilityFunc({ updates, email }));
      callFunctionEnd();
      
      const processUpdateEnd = logger.start('process_update');
      if (result.data.success) {
        setAvailability(prev => {
          const newAvailability = { ...prev };
          updates.forEach(update => {
            newAvailability[update.date] = update.status;
          });
          return newAvailability;
        });
      }
      processUpdateEnd();
      
      return result.data.success;
    } catch (error) {
      // Error handling remains intact
      return false;
    } finally {
      end();
    }
  };

  return { availability, isLoading, updateAvailability };
};